import styleFn, {compose} from '../util'

const flexDir = styleFn({
  propName: 'flexDir',
  cssProp: 'flex-direction'
})

const flexBasis = styleFn({
  propName: 'flexBasis',
  cssProp: 'flex-basis'
})

const flexJustify = styleFn({
  propName: 'flexJustify',
  cssProp: 'justify-content'
})

const flexAlign = styleFn({
  propName: 'flexAlign',
  cssProp: 'align-items'
})

const flex = styleFn({propName: 'flex'})

export default compose(
  flex,
  flexDir,
  flexBasis,
  flexJustify,
  flexAlign
)
